var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__files" },
    [
      _c("hr"),
      _vm._v(" "),
      _c(
        "IcFormRowWrapper",
        {
          attrs: {
            id: "files",
            name: "files",
            label: _vm.$t("label_attachment"),
            labelWidth: 4,
            controlWidth: 8,
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ validator }) {
                return [
                  _c("IcInputFile", {
                    attrs: { id: "file", v: validator, maxFiles: _vm.maxFiles },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("input", $event)
                      },
                    },
                    model: {
                      value: _vm.files,
                      callback: function ($$v) {
                        _vm.files = $$v
                      },
                      expression: "files",
                    },
                  }),
                ]
              },
            },
          ]),
        },
        [_vm._v("\n    errr!\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _vm._v(_vm._s(_vm.$t("label_max_filesize"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }